import React, { forwardRef } from 'react';
import { Chip, ChipProps } from '@mui/material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

import focusRing from '../../theme/focus';

// The outlined pill of chips.md 7.27 shared by the page tag, "Include this
// page" and attached files in the Pingwin composer's attachment row.
const PinguComposerChip = forwardRef<HTMLDivElement, ChipProps>(({ sx, ...props }, ref) => (
  <Chip
    ref={ref}
    size="small"
    variant="outlined"
    deleteIcon={<CloseOutlinedIcon />}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
    sx={[
      {
        maxWidth: '100%',
        height: 22,
        bgcolor: 'background.paper',
        borderColor: 'divider',
        color: 'text.primary',
        fontSize: 12,
        '&.MuiChip-clickable:hover, &.Mui-focusVisible': { bgcolor: 'background.paper' },
        '&:focus-visible': { boxShadow: focusRing },
        '& .MuiChip-icon': { fontSize: 14, color: 'text.secondary' },
        // The padding keeps the click area at 24px although the chip is 22px
        // tall, and the negative margin keeps the icon where it was.
        '& .MuiChip-deleteIcon': {
          fontSize: 14,
          color: 'text.secondary',
          boxSizing: 'content-box',
          p: '5px',
          m: '-5px -1px -5px -9px',
          '&:hover': { color: 'text.primary' },
        },
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  />
));

PinguComposerChip.displayName = 'PinguComposerChip';

export default PinguComposerChip;
